import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	open: false,
	loading: false,
	type: null
};

export const loaderSlice = createSlice({
	name: "loader",
	initialState,
	reducers: {
		loader: (state, action) => {
			state.open = action.payload;
			state.loading = action.payload;
			state.type = action.payload.type || null;
		}
	}
});

export const { loader } = loaderSlice.actions;
export default loaderSlice.reducer;
